import {
  Slider, StyledInput,
} from './styles';

const Input = ({
  left, onChange, color, edgeColor,
}) => (
  <Slider>
    <StyledInput
      onInput={(e) => onChange(e.target.value)}
      type="range"
      style={{
        width: '100%',
        '--min': 0,
        '--max': 100,
        '--val': left,
        '--color': color,
        '--edgeColor': edgeColor,
      }}
    />
  </Slider>
);

export default Input;
